<template>
    <v-dialog v-model="dialog" max-width="700px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          small
          class="mx-1"
          >fas fa-tasks
        </v-icon>
      </template>
      <v-card>
        <v-card-title>
        <v-row class="ma-0">
        <v-col cols="2">
          <span class="headline">Tasks</span>
        </v-col>
        <v-col cols="7">
            <v-row>
                <v-col cols="5" class="pa-0">
                    <v-select
                    :items="['Pending','Hold','Done']"
                    label="Task Status"
                    v-model="status"
                    clearable="true"
                    class="pt-0"
                    ></v-select>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="5" class="pa-0">
                    <v-select
                    :items="['Low','Medium','High']"
                    label="Task Priority"
                    v-model="priority"
                    clearable="true"
                    class="pt-0"
                    ></v-select>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="3">
          <AddTask :projectid="projectid"/>
        </v-col>
        </v-row>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="12">
                <v-simple-table class="w-100">
                    <template v-slot:default>
                        <thead>
                            <tr>
                            <th>Task</th>
                            <th>Assign To</th>
                            <th>Project Name</th>
                            <th>Priority</th>
                            <th>Status</th>
                            <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="task in filtertasks" :key="task.id">
                                <td>{{ task.task }}</td>
                                <td>{{ task.assignto.name }}</td>
                                <td>{{ task.project.title }}</td>
                                <td><span :class="task.priority == 'Low' ? 'lightblue--text' : (task.priority == 'Medium') ? 'orange--text' : 'red--text'">{{ task.priority }}</span></td>
                                <td>
                                    <v-chip class="ma-1" v-if="task.status == 0" small color="error">pending</v-chip>
                                    <v-chip class="ma-1" v-if="task.status == 1" small color="warning">hold</v-chip>
                                    <v-chip class="ma-1" v-if="task.status == 2" small color="success">done</v-chip>
                                </td>
                                <td>
                                  <v-btn color="warning" class="mr-2" v-if="task.status == 0" x-small @click.prevent="holdtask(task)">hold</v-btn>
                                    <v-btn color="info" class="mr-2" v-if="task.status == 1" x-small @click.prevent="unholdtask(task)">unhold</v-btn>
                                    <v-btn color="success" class="ml-1" v-if="task.status != 2" x-small @click.prevent="donetask(task)">done</v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                </v-col>
            </v-row>
        </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import AddTask from './AddTask.vue';
import sendMessage from '../apis/sendMessage.js';
  export default {
    components: {
        AddTask
    },
    props : {
        tasks: Array,
        projectid : Number
    },
    data: function() {
      return {
        dialog: false,
        status : '',
        priority: '',
      }
    },
    computed: {
      filtertasks() {
          return this.tasks.filter(task => {
            if(this.priority) { return this.priority === task.priority;}
            return true;
            })
            .filter(task => {
            if(this.status == "Pending") { return  0 === task.status;}
            else if(this.status == "Hold") { return  1 === task.status;}
            else if(this.status == "Done") { return  2 === task.status;}
            else {
              return !(2 === task.status);
            }
            //return true;
            });
      }
    },
    methods:{
      ...mapActions(['edittask']),
      holdtask(task) {
          task.status = 1;
          this.edittask(task).then(() => {
            let msg = `Task "${task.task}" in Project "${task.project.title}" is on hold.`;
            sendMessage(msg);

          });
      },
      unholdtask(task) {
          task.status = 0;
          this.edittask(task).then(() => {
            let msg = `Task "${task.task}" in Project "${task.project.title}" is Un-hold successfully.`;
            sendMessage(msg);
          });
      },
      donetask(task) {
          task.status = 2;
          this.edittask(task).then(() => {
            let msg = `✅ ${task.task} <pre>\n</pre> 💼 ${task.project.title}`;
            sendMessage(msg);
          });
      }
    },
  }
</script>